import React, { useCallback, useEffect, useRef, useState } from 'react'
import { Breadcrumb, CardBasic, DateRangeP, SButton, SFooter, SImage } from '../../components';
import Select from 'react-select';
import { AvatarMale } from '../../assets'
import { useLocation } from 'react-router-dom';
import { API_BASE_URL } from '../../config';

function PackageHistory() {
    const location = useLocation();
    const data = location.state;
    const [loading, setLoading] = useState(true);
    const [patientData, setPatientData] = useState(null);
    const [paymentHistory, setPaymentHistory] = useState(null);

    const Patient = useCallback(async () => {
        try {
            const token = localStorage.getItem('access_token');
            const response = await fetch(
                `${API_BASE_URL}/auth/patient/norm/${data.no_medical_record}`,
                {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        ...(token && { Authorization: `Bearer ${token}` }),
                    }
                }
            );
            if(!response.ok) {
                const errorData = await response.json().catch(() => ({}));
                alert(errorData.message || 'Gagal mengambil data!');
                setLoading(false);
                return;
            }
            const patientDatas = await response.json();
            setPatientData(patientDatas.data[0]);
        }finally{
            setLoading(false);
        }
    }, [data]);

    const PaymentHistory = useCallback(async () => {
        try {
            const token = localStorage.getItem('access_token');
            const response = await fetch(
                `${API_BASE_URL}/auth/patient_transaction/${data.klinik_id}/${data.no_medical_record}`,
                {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        ...(token && { Authorization: `Bearer ${token}` }),
                    }
                }
            );

            if (!response.ok) {
                const errorData = await response.json().catch(() => ({}));
                alert(errorData.message || 'Gagal mengambil data!');
                setPaymentHistory({
                    message: 'Data Not Found',
                    code: 404,
                    data: []
                });
                setLoading(false);
                return;
            }

            const paymentHistoryData = await response.json();
            setPaymentHistory({
                message: paymentHistoryData.message,
                code: paymentHistoryData.code,
                data: paymentHistoryData.data
            });
        } catch (error) {
            setPaymentHistory({
                message: 'Gagal mengambil data!',
                code: 500,
                data: []
            });
        }
    }, [data]);

    useEffect(() => {
        if(loading){
            Promise.all([
                Patient(),
                PaymentHistory()
            ])
            .finally(() => 
                setLoading(false)
        );
        }
    }, [loading,Patient, PaymentHistory]);

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '300px' }}>
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }
    
  const Profile = () => {
    function formatDateInternational(dateString) {
        if (!dateString) return '';
        const monthIntl = [
            'January', 'February', 'March', 'April', 'May', 'June',
            'July', 'August', 'September', 'October', 'November', 'December'
        ];
        const d = new Date(dateString);
        if (isNaN(d)) return '';
        const day = String(d.getDate()).padStart(2, '0');
        const month = monthIntl[d.getMonth()];
        const year = d.getFullYear();
        return `${day} ${month} ${year}`;
    }

    return (
        <>
            <div className="d-flex flex-column mb-5">
                <div className="symbol symbol-100px symbol-circle mb-7 text-center">
                    <SImage 
                        alt={'No Avatars'}
                        source={AvatarMale}
                        width={'50px'}
                        height={'50px'}
                    />
                </div>
                <h3 className='fs-3 text-gray-800 fw-bold mb-1 text-center'>{patientData?.full_name}</h3>
                <h5 className="fs-5 fw-semibold text-muted mb-6 text-center">{patientData?.email}</h5>

                <div className="d-flex flex-stack fs-4 py-3">
                    <div className="fw-bold rotate collapsible" 
                    data-bs-toggle="collapse" 
                    href="#kt_view" 
                    role="button" 
                    aria-expanded="false" 
                    aria-controls="kt_view">Details
                        <span className="ms-2 rotate-180">
                            <i className="ki-outline ki-down fs-3"></i>
                        </span>
                    </div>
                    <span className="btn btn-sm btn-light-primary">
                        Platinum
                    </span>
                </div>
                <div className="separator separator-dashed my-3"></div>
                <div id="kt_view" className="collapse show">
                    <div className="py-5 fs-6">
                        <div className="fw-bold mt-5">No. Medical Record</div>
                        <div className="text-gray-600">{patientData?.no_medical_record}</div>
                        <div className="fw-bold mt-5">Address</div>
                        <div className="text-gray-600">{patientData?.address}</div>
                        <div className="fw-bold mt-5">Phone Number</div>
                        <div className="text-gray-600">{patientData?.phone_number}</div>
                        <div className="fw-bold mt-5">Join Date</div>
                        <div className="text-gray-600">{formatDateInternational(patientData?.created_at)}</div>
                        <div className="fw-bold mt-5">Top Transaction</div>
                        <div className="text-gray-600">Rp. 14.200.000,00</div>
                        <div className="fw-bold mt-5">Deposit Balance</div>
                        <div className="text-gray-600">Rp. 2.000.000,00</div>
                    </div>
                </div>
            </div>
        </>
    )
  }

  const Tab = () => {

    const PackageHistory = () => {
        return (
            <>
            <div className='row row-cols-1 row-cols-md-2 mb-6 mb-xl-9'>
                <div className='col-sm-6 col-sm-6 col-md-6 col-lg-6'>
                    <CardBasic
                    className={'h-100'}
                    className3={'flex-nowrap border-0 pt-9'}
                    header={
                        <>
                            <div className='card-title m-0'>
                                <h2 className="fw-bold">Reward Points</h2>
                            </div>
                        </>
                        
                    }
                    className2={'pt-0'}
                    children={
                        <>
                            <div className="fw-bold fs-2">
                                <div className="d-flex">
                                    <i className="ki-outline ki-heart text-info fs-2x"></i>
                                    <div className="ms-2">4,571
                                    <span className="text-muted fs-4 fw-semibold m-2">Points earned</span></div>
                                </div>
                                <div className="fs-7 fw-normal text-muted">Earn reward points with every purchase.</div>
                            </div>
                        </>
                    }
                    />
                </div>
                <div className='col-sm-6 col-md-6 col-lg-6'>
                    <CardBasic
                    className={'h-100'}
                    className3={'flex-nowrap border-0 pt-9'}
                    className2={'bg-info hoverable h-md-100 rounded'}
                    children={
                        <>
                                <i className="ki-outline ki-award text-white fs-3x ms-n1"></i>
                                <div className="text-white fw-bold fs-2 mt-5">Premium Member</div>
                                <div className="fw-semibold text-white">Tier Milestone Reached</div>
                        </>
                    }
                    />
                </div>
            </div>
            
            <CardBasic 
                className={'pt-4 mb-6 mb-xl-9'}
                className3={'border-0'}
                header={
                    <>
                        <div className="card-title">
                            <h2>Package History</h2>
                        </div>
                    </>
                }
                className2={'pt-0 pb-5'}
                children={
                    <>
                        <div className='py-0'>
                            <div className='py-3 d-flex flex-stack flex-wrap'>
                                <div className="d-flex align-items-center collapsible collapsed rotate" data-bs-toggle="collapse" href="#kt_pack_1" role="button" aria-expanded="false" aria-controls="kt_customer_view_payment_method_1">
                                    <div className="me-3 rotate-90">
                                        <i className="ki-outline ki-right fs-3"></i>
                                    </div>
                                    <div className="me-3">
                                        <div className="d-flex align-items-center">
                                            <div className="fs-6 fw-bold">(3x) Acupunture</div>
                                            <div className="badge badge-light-primary ms-5">2/3</div>
                                        </div>
                                        <div className="text-muted">Transaction Date : 29/11/2024</div>
                                    </div>
                                </div>
                            </div>
                            <div id="kt_pack_1" className="collapse fs-6 ps-9" data-bs-parent="#kt_packs_1">
                                <div className="d-flex flex-column pb-5">
                                    <div className="text-muted">29/01/2023, <span className='fw-bold'>1x Telah Digunakan</span></div>
                                    <div className="text-muted">03/02/2023, <span className='fw-bold'>1x Telah Digunakan</span></div>
                                </div>
                            </div>
                        </div>
                        <div className='py-0'>
                            <div className='py-3 d-flex flex-stack flex-wrap'>
                                <div className="d-flex align-items-center collapsible collapsed rotate" data-bs-toggle="collapse" href="#kt_pack_2" role="button" aria-expanded="false" aria-controls="kt_customer_view_payment_method_1">
                                    <div className="me-3 rotate-90">
                                        <i className="ki-outline ki-right fs-3"></i>
                                    </div>
                                    <div className="me-3">
                                        <div className="d-flex align-items-center">
                                            <div className="fs-6 fw-bold">(10x) Bars Therapy</div>
                                            <div className="badge badge-light-primary ms-5">2/10</div>
                                        </div>
                                        <div className="text-muted">Transaction Date : 29/11/2024</div>
                                    </div>
                                </div>
                            </div>
                            <div id="kt_pack_2" className="collapse fs-6 ps-9" data-bs-parent="#kt_packs_2">
                                <div className="d-flex flex-column pb-5">
                                    <div className="text-muted">29/01/2023, <span className='fw-bold'>1x Telah Digunakan</span></div>
                                    <div className="text-muted">03/02/2023, <span className='fw-bold'>1x Telah Digunakan</span></div>
                                </div>
                            </div>
                        </div>
                    </>
                }
            />
            </>
        )
    }

    const PaymentRecord = ({ paymentHistory }) => {
        // const [datas, setDatas] = useState(data ? data.data : []);
        const [activeIndex, setActiveIndex] = useState(null);
        const [selectedStatus, setSelectedStatus] = useState({label: 'All',value: 'All'});
        const [dateRange, setDateRange] =  useState({
            startDate: new Date(),
            endDate: new Date(),
        });
        const dropdownRef = useRef([]);
        const datas = paymentHistory?.data ? paymentHistory.data : [];
        // console.log(datas);
        const arr = [
            {label: 'All',value: 'All'},
            {label: 'Success',value: 'Success'},
            {label: 'Refund',value: 'Refund'},
            {label: 'Canceled',value: 'Canceled'}
        ];

        const actions = () => {
            return (
                <>
                    <i className="ki-outline fs-2"></i>Actions
                </>
            )
        }

        const toggleAction = (index) => {
            setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
        };

        const handleStatusChange = (selectedOption) => {
            setSelectedStatus(selectedOption);
        };

        useEffect(() => {
            const handleClickOutside = (event) => {
                if (
                    activeIndex !== null &&
                    dropdownRef.current[activeIndex] &&
                    !dropdownRef.current[activeIndex].contains(event.target)
                ) {
                    setActiveIndex(null);
                }
            };

            document.addEventListener("click", handleClickOutside);
            return () => {
                document.removeEventListener("click", handleClickOutside);
            };
        }, [activeIndex]);

        return (
            <>
                <CardBasic 
                    className={'pt-4 mb-6 mb-xl-9'}
                    className3={'border-0'}
                    header={
                    <>
                        <div className="card-title">
                            <h2>Payment Record & Receipt</h2>
                        </div>
                        <div className="card-toolbar flex-row-fluid justify-content-end gap-5">
                            <DateRangeP
                                selectedDate={dateRange}
                                setSelectedDate={setDateRange}
                            />
                            <div className="w-150px">
                                <Select
                                    className=""
                                    options={arr}
                                    placeholder="Status"
                                    isSearchable={false}
                                    value={selectedStatus}
                                    onChange={handleStatusChange}
                                />
                            </div>
                        </div>
                    </>
                    }
                    children={
                    <>
                        <div className="table-responsive">
                            <table className="table align-middle table-row-dashed fs-6 gy-5">
                                <thead>
                                    <tr className="text-start text-gray-500 fw-bold fs-7 text-uppercase gs-0">
                                        <th className="min-w-100px">ACTIONS</th>
                                        <th className="min-w-100px">NAME PATIENT</th>
                                        <th className="min-w-75px">NO MR</th>
                                        <th className="min-w-100px">PHONE NUMBER</th>
                                        <th className="min-w-100px">NO IDENTITY</th>
                                        <th className="min-w-75px">GENDER</th>
                                        <th className="min-w-75px">STATUS</th>
                                    </tr>
                                </thead>
                                <tbody className="fw-semibold text-gray-600">
                                    {
                                        datas.length > 0 ? datas.map((item, index) => (
                                            <tr key={index}>
                                                <td ref={(el) => (dropdownRef.current[index] = el)}>
                                                    <SButton
                                                        className={"btn btn-light-secondary"}
                                                        children={actions()}
                                                        action={() => toggleAction(index)}
                                                    />
                                                </td>
                                                <td>{patientData?.full_name}</td>
                                                <td>{item.no_medical_record}</td>
                                                <td>{patientData?.phone_number}</td>
                                                <td>{patientData?.identity_number}</td>
                                                <td>{patientData?.gender}</td>
                                                <td>{item.status}</td>
                                            </tr>
                                        )) : (
                                            <tr>
                                                <td colSpan={'7'} className='text-center'>Data Not Found</td>
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                    </>
                    }
                />
            </>
        )
    }
    
    const HistoryTreatment = () => {
        const [datas, setDatas] = useState([]);
        const [activeIndex, setActiveIndex] = useState(null);
        const [selectedStatus, setSelectedStatus] = useState({label: 'All',value: 'All'});
        const [dateRange, setDateRange] =  useState({
            startDate: new Date(),
            endDate: new Date(),
        });
        const dropdownRef = useRef([]);

        const arr = [
            {label: 'All',value: 'All'},
            {label: 'Success',value: 'Success'},
            {label: 'Refund',value: 'Refund'},
            {label: 'Canceled',value: 'Canceled'}
        ];

        const actions = () => {
            return (
                <>
                    <i className="ki-outline fs-2"></i>Actions
                </>
            )
        }

        const toggleAction = (index) => {
            setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
        };

        const handleStatusChange = (selectedOption) => {
            setSelectedStatus(selectedOption);
        };

        useEffect(() => {
            const handleClickOutside = (event) => {
                if (
                    activeIndex !== null &&
                    dropdownRef.current[activeIndex] &&
                    !dropdownRef.current[activeIndex].contains(event.target)
                ) {
                    setActiveIndex(null);
                }
            };

            document.addEventListener("click", handleClickOutside);
            return () => {
                document.removeEventListener("click", handleClickOutside);
            };
        }, [activeIndex]);

        return (
            <>
                <CardBasic 
                    className={'pt-4 mb-6 mb-xl-9'}
                    className3={'border-0'}
                    header={
                    <>
                        <div className="card-title">
                            <h2>History Treatment</h2>
                        </div>
                        <div className="card-toolbar flex-row-fluid justify-content-end gap-5">
                            <DateRangeP
                                selectedDate={dateRange}
                                setSelectedDate={setDateRange}
                            />
                            <div className="w-150px">
                                <Select
                                    className=""
                                    options={arr}
                                    placeholder="Status"
                                    isSearchable={false}
                                    value={selectedStatus}
                                    onChange={handleStatusChange}
                                />
                            </div>
                        </div>
                    </>
                    }
                    children={
                    <>
                        <div className="table-responsive">
                            <table className="table align-middle table-row-dashed fs-6 gy-5">
                                <thead>
                                    <tr className="text-start text-gray-500 fw-bold fs-7 text-uppercase gs-0">
                                        <th className="min-w-100px">ACTIONS</th>
                                        <th className="min-w-100px">NAME PATIENT</th>
                                        <th className="min-w-75px">NO MR</th>
                                        <th className="min-w-100px">PHONE NUMBER</th>
                                        <th className="min-w-100px">NO IDENTITY</th>
                                        <th className="min-w-75px">GENDER</th>
                                        <th className="min-w-75px">STATUS</th>
                                    </tr>
                                </thead>
                                <tbody className="fw-semibold text-gray-600">
                                    {
                                        datas.length > 0 ? datas.map((item, index) => (
                                            <tr key={index}>
                                                <td ref={(el) => (dropdownRef.current[index] = el)}>
                                                    <SButton
                                                        className={"btn btn-light-secondary"}
                                                        children={actions()}
                                                        action={() => toggleAction(index)}
                                                    />
                                                </td>
                                                <td>{item.patient}</td>
                                                <td>{item.nomr}</td>
                                                <td>{item.phone}</td>
                                                <td>{item.patient}</td>
                                                <td>{item.patient}</td>
                                                <td>{item.patient}</td>
                                            </tr>
                                        )) : (
                                            <tr>
                                                <td colSpan={'7'} className='text-center'>Data Not Found</td>
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                    </>
                    }
                />
            </>
        )
    }

    const CustomerDeposit = () => {
        const [datas, setDatas] = useState([]);
        const [activeIndex, setActiveIndex] = useState(null);
        const [selectedStatus, setSelectedStatus] = useState({label: 'All',value: 'All'});
        const [dateRange, setDateRange] =  useState({
            startDate: new Date(),
            endDate: new Date(),
        });
        const dropdownRef = useRef([]);

        const arr = [
            {label: 'All',value: 'All'},
            {label: 'Success',value: 'Success'},
            {label: 'Refund',value: 'Refund'},
            {label: 'Canceled',value: 'Canceled'}
        ];

        const actions = () => {
            return (
                <>
                    <i className="ki-outline fs-2"></i>Actions
                </>
            )
        }

        const toggleAction = (index) => {
            setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
        };

        const handleStatusChange = (selectedOption) => {
            setSelectedStatus(selectedOption);
        };

        useEffect(() => {
            const handleClickOutside = (event) => {
                if (
                    activeIndex !== null &&
                    dropdownRef.current[activeIndex] &&
                    !dropdownRef.current[activeIndex].contains(event.target)
                ) {
                    setActiveIndex(null);
                }
            };

            document.addEventListener("click", handleClickOutside);
            return () => {
                document.removeEventListener("click", handleClickOutside);
            };
        }, [activeIndex]);

        return (
            <>
                <CardBasic 
                    className={'pt-4 mb-6 mb-xl-9'}
                    className3={'border-0'}
                    header={
                    <>
                        <div className="card-title">
                            <h2>Customer Deposit</h2>
                        </div>
                        <div className="card-toolbar flex-row-fluid justify-content-end gap-5">
                            <DateRangeP
                                selectedDate={dateRange}
                                setSelectedDate={setDateRange}
                            />
                            <div className="w-150px">
                                <Select
                                    className=""
                                    options={arr}
                                    placeholder="Status"
                                    isSearchable={false}
                                    value={selectedStatus}
                                    onChange={handleStatusChange}
                                />
                            </div>
                        </div>
                    </>
                    }
                    children={
                    <>
                        <div className="table-responsive">
                            <table className="table align-middle table-row-dashed fs-6 gy-5">
                                <thead>
                                    <tr className="text-start text-gray-500 fw-bold fs-7 text-uppercase gs-0">
                                        <th className="min-w-100px">ACTIONS</th>
                                        <th className="min-w-100px">NAME PATIENT</th>
                                        <th className="min-w-75px">NO MR</th>
                                        <th className="min-w-100px">PHONE NUMBER</th>
                                        <th className="min-w-100px">NO IDENTITY</th>
                                        <th className="min-w-75px">GENDER</th>
                                        <th className="min-w-75px">STATUS</th>
                                    </tr>
                                </thead>
                                <tbody className="fw-semibold text-gray-600">
                                    {
                                        datas.length > 0 ? datas.map((item, index) => (
                                            <tr key={index}>
                                                <td ref={(el) => (dropdownRef.current[index] = el)}>
                                                    <SButton
                                                        className={"btn btn-light-secondary"}
                                                        children={actions()}
                                                        action={() => toggleAction(index)}
                                                    />
                                                </td>
                                                <td>{item.patient}</td>
                                                <td>{item.nomr}</td>
                                                <td>{item.phone}</td>
                                                <td>{item.patient}</td>
                                                <td>{item.patient}</td>
                                                <td>{item.patient}</td>
                                            </tr>
                                        )) : (
                                            <tr>
                                                <td colSpan={'7'} className='text-center'>Data Not Found</td>
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                    </>
                    }
                />
            </>
        )
    }

    const AppointmentHistory = () => {
        const [datas, setDatas] = useState([]);
        const [activeIndex, setActiveIndex] = useState(null);
        const [selectedStatus, setSelectedStatus] = useState({label: 'All',value: 'All'});
        const [dateRange, setDateRange] =  useState({
            startDate: new Date(),
            endDate: new Date(),
        });
        const dropdownRef = useRef([]);

        const arr = [
            {label: 'All',value: 'All'},
            {label: 'Success',value: 'Success'},
            {label: 'Refund',value: 'Refund'},
            {label: 'Canceled',value: 'Canceled'}
        ];

        const actions = () => {
            return (
                <>
                    <i className="ki-outline fs-2"></i>Actions
                </>
            )
        }

        const toggleAction = (index) => {
            setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
        };

        const handleStatusChange = (selectedOption) => {
            setSelectedStatus(selectedOption);
        };

        useEffect(() => {
            const handleClickOutside = (event) => {
                if (
                    activeIndex !== null &&
                    dropdownRef.current[activeIndex] &&
                    !dropdownRef.current[activeIndex].contains(event.target)
                ) {
                    setActiveIndex(null);
                }
            };

            document.addEventListener("click", handleClickOutside);
            return () => {
                document.removeEventListener("click", handleClickOutside);
            };
        }, [activeIndex]);

        return (
            <>
                <CardBasic 
                    className={'pt-4 mb-6 mb-xl-9'}
                    className3={'border-0'}
                    header={
                    <>
                        <div className="card-title">
                            <h2>Appointment History</h2>
                        </div>
                        <div className="card-toolbar flex-row-fluid justify-content-end gap-5">
                            <DateRangeP
                                selectedDate={dateRange}
                                setSelectedDate={setDateRange}
                            />
                            <div className="w-150px">
                                <Select
                                    className=""
                                    options={arr}
                                    placeholder="Status"
                                    isSearchable={false}
                                    value={selectedStatus}
                                    onChange={handleStatusChange}
                                />
                            </div>
                        </div>
                    </>
                    }
                    children={
                    <>
                        <div className="table-responsive">
                            <table className="table align-middle table-row-dashed fs-6 gy-5">
                                <thead>
                                    <tr className="text-start text-gray-500 fw-bold fs-7 text-uppercase gs-0">
                                        <th className="min-w-100px">ACTIONS</th>
                                        <th className="min-w-100px">NAME PATIENT</th>
                                        <th className="min-w-75px">NO MR</th>
                                        <th className="min-w-100px">PHONE NUMBER</th>
                                        <th className="min-w-100px">NO IDENTITY</th>
                                        <th className="min-w-75px">GENDER</th>
                                        <th className="min-w-75px">STATUS</th>
                                    </tr>
                                </thead>
                                <tbody className="fw-semibold text-gray-600">
                                    {
                                        datas.length > 0 ? datas.map((item, index) => (
                                            <tr key={index}>
                                                <td ref={(el) => (dropdownRef.current[index] = el)}>
                                                    <SButton
                                                        className={"btn btn-light-secondary"}
                                                        children={actions()}
                                                        action={() => toggleAction(index)}
                                                    />
                                                </td>
                                                <td>{item.patient}</td>
                                                <td>{item.nomr}</td>
                                                <td>{item.phone}</td>
                                                <td>{item.patient}</td>
                                                <td>{item.patient}</td>
                                                <td>{item.patient}</td>
                                            </tr>
                                        )) : (
                                            <tr>
                                                <td colSpan={'7'} className='text-center'>Data Not Found</td>
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                    </>
                    }
                />
            </>
        )
    }

    return(
        <>
            <div className="flex-lg-row-fluid ms-lg-15">
                <ul className='nav nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x border-0 fs-6 fw-semibold mb-8'>
                    <li className='nav-item'>
                        <a className="nav-link text-active-primary pb-4 active" data-bs-toggle="tab" href="#kt_package_history">Package History</a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link text-active-primary pb-4" data-bs-toggle="tab" href="#kt_payment_record">Payment Record & Receipt</a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link text-active-primary pb-4" data-bs-toggle="tab" href="#kt_history_treatment">History Treatment</a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link text-active-primary pb-4" data-bs-toggle="tab" href="#kt_customer_deposit">Customer Deposit</a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link text-active-primary pb-4" data-bs-toggle="tab" href="#kt_appointment_history">Appointment History</a>
                    </li>
                </ul>
                <div className="tab-content" id="myTabContent">
                    <div className="tab-pane fade show active" id="kt_package_history" role="tabpanel">
                        <PackageHistory />
                    </div>
                    <div className="tab-pane fade" id="kt_payment_record" role="tabpanel">
                        <PaymentRecord paymentHistory={paymentHistory}/>
                    </div>
                    <div className="tab-pane fade" id="kt_history_treatment" role="tabpanel">
                        <HistoryTreatment />
                    </div>
                    <div className="tab-pane fade" id="kt_customer_deposit" role="tabpanel">
                        <CustomerDeposit />
                    </div>
                    <div className="tab-pane fade" id="kt_appointment_history" role="tabpanel">
                        <AppointmentHistory />
                    </div>
                </div>
            </div>
        </>
    )
  }

  return (
    <>
    <div className='app-wrapper flex-column flex-row-fluid' id='kt_app_wrapper'>
        <Breadcrumb title={'Home'} header={'Package History'}/>
        <div className='app-container container-xxl d-flex'>
            <div className='app-main flex-column flex-row-fluid' id="kt_app_main">
                <div className='d-flex flex-column flex-column-fluid'>
                    <div className='app-content'>
                        <div className="d-flex flex-column flex-xl-row">
                            <div className="flex-column flex-lg-row-auto w-100 w-xl-350px mb-10">
                                <CardBasic 
                                    className={'mb-5 mb-xl-8'}
                                    className2={'pt-15'}
                                    children={Profile()}
                                />
                            </div>
                            <Tab />
                        </div>
                    </div>
                </div>
                <SFooter />     
            </div>
        </div>
    </div>
    </>
  )
}

export default PackageHistory